<template>
    <section class="hero is-flex main">
        <div class="card" style="width: 100%;">
            <div class="card-content">
                <div class="img1 practice-bg"><img src="../assets/images/cap.png" alt=""></div>
                <div class="img2 practice-bg"><img src="../assets/images/cross.png" alt=""></div>
                <div class="img3 practice-bg"><img src="../assets/images/clock.png" alt=""></div>
                <div class="img4 practice-bg">
                    <div class="img4-inner">
                        <img class="pencil" src="../assets/images/pencil.png" alt="">
                        <img src="../assets/images/bird.png" alt="">
                    </div>

                </div>
                <div class="img5 practice-bg"><img src="../assets/images/stars.png" alt=""></div>
                <div class="img6 practice-bg"><img src="../assets/images/rainbow2.png" alt=""></div>
                <div class="img7 practice-bg"><img src="../assets/images/cloud4.png" alt=""></div>
                <div class="tabs">
                    <ul>
                        <li >
                            <a href="practice">
                                <span>Practice</span>
                            </a>
                        </li>
                        <li class="active">
                            <a href="analytics">
                                <span style="color: #fff;font-weight: bold;">Analytic</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div id="tab-content">
                    <div class="practice-tab" id="practice">
                        <b-loading :is-full-page="true" v-model="isLoading"></b-loading>

                        <div class="card-container">
                            <div style="border-radius:0; width: 100%" class="box">
                                <div class="columns">
                                    <div class="column is-8">
                                        <div class="is-flex is-align-items-center">
                                            <img style="height: 40px;margin-right: 20px;"
                                                :src="require('@/assets/images/icons/analytics-rising.png')" />
                                            <p class="title is-3">{{ fetchCurrentKid ? `${fetchCurrentKid.name}'s` : null }}
                                                Progress</p>
                                        </div>
                                    </div>
                                    <div class="column has-text-right">
                                        <b-dropdown v-model="grade" @input="changeThisGradeSubject()"
                                            class="has-text-left" aria-role="list">
                                            <template #trigger="{ active: isGradeSelectActive }">
                                                <b-button
                                                    :label="grade ? fetchGrades.find(g => g._id === grade).name : 'Select grade here'"
                                                    type="is-light"
                                                    :icon-right="isGradeSelectActive ? 'menu-up' : 'menu-down'" style="z-index: 10;"/>
                                            </template>
                                            <b-dropdown-item v-for="grade_row in fetchGrades" :key="grade_row._id"
                                                :value="grade_row._id" aria-role="listitem">{{ grade_row.name
                                                }}</b-dropdown-item>
                                        </b-dropdown>

                                        <b-dropdown v-model="subject" @input="changeThisGradeSubject()"
                                            class="has-text-left" aria-role="list">
                                            <template #trigger="{ active: isSubjectSelectActive }">
                                                <b-button
                                                    :label="subject ? fetchSubjects.find(s => s._id === subject).name : 'Select subject here'"
                                                    type="is-light"
                                                    :icon-right="isSubjectSelectActive ? 'menu-up' : 'menu-down'" style="z-index: 10;"/>
                                            </template>
                                            <b-dropdown-item v-for="subject_row in fetchSubjects" :key="subject_row._id"
                                                :value="subject_row._id" aria-role="listitem">{{ subject_row.name
                                                }}</b-dropdown-item>
                                        </b-dropdown>

                                        <!--Arrow Divider Start-->
                                        <div v-if="grade_subject" class="columns mt-2">
                                            <img style="width: 50px;transform: rotate(10deg);margin-right:20px;margin-left: auto;"
                                                :src="require('@/assets/images/icons/analytics/zigzag-arrow.svg')" />
                                        </div>
                                        <!--Arrow Divider End-->
                                    </div>
                                </div>

                                <div v-if="!grade_subject">
                                    <p class="title is-2 is-flex is-justify-content-center mt-6">
                                        <span>Please select a grade to view Analytics</span>
                                        <span><img style="width: 50px;"
                                                :src="require('@/assets/images/icons/arrow-top-right.svg')" /></span>
                                    </p>
                                </div>
                                <div v-else>
                                    <!--Summary Cards-->
                                    <div v-if="fetchAnalyticsSummary"
                                        class="columns is-gapless is-multiline mb-0 is-align-items-center">
                                        <div class="column is-3 has-text-centered">
                                            <summary-tile backgroundColor="#C0EEE4" title="Questions answered"
                                                :value="fetchAnalyticsSummary.questions_attempted"
                                                :icon="require('@/assets/images/icons/analytics/questions-answered.svg')" />
                                        </div>
                                        <div class="column is-3 has-text-centered ">
                                            <summary-tile backgroundColor="#F8F988" title="Time Practiced"
                                                :value="timePracticedText"
                                                :icon="require('@/assets/images/icons/analytics/hour-glass.svg')" />
                                        </div>
                                        <div class="column is-3 has-text-centered">
                                            <summary-tile backgroundColor="#FFCAC8" title="Skills practiced"
                                                :value="fetchAnalyticsSummary.skills_practiced"
                                                :icon="require('@/assets/images/icons/analytics/skills-practiced.svg')" />
                                        </div>
                                        <div class="column is-3 has-text-centered">
                                            <img style="height: 150px"
                                                :src="require('@/assets/images/icons/analytics/sticker-learning.svg')">
                                        </div>
                                    </div>

                                    <!--Arrow Divider Start-->
                                    <div class="mt-2 columns is-flex is-justify-content-center">
                                        <img style="height: 100px;"
                                            :src="require('@/assets/images/icons/analytics/down-arrow-swirl-red.svg')" />
                                    </div>
                                    <!--Arrow Divider End-->

                                    <div v-if="fetchAnalyticsSummary" class="columns is-multiline">
                                        <!--Summary Questions Practiced per day graph-->
                                        <div class="column is-12">
                                            <div class="columns">
                                                <div class="column is-9">
                                                    <p class="title is-5"><span class="analytics-title">Questions Practiced
                                                            on different
                                                            days</span></p>
                                                </div>
                                                <div class="column is-3 has-text-right">
                                                    <b-dropdown @input="changeDateReportType" v-model="dateReportType"
                                                        class="has-text-left" aria-role="list">
                                                        <template #trigger="{ active: isDateGraphReportTypeActive }">
                                                            <b-button :label="`Select Report Type: ${dateReportType}`"
                                                                type="is-light"
                                                                :icon-right="isDateGraphReportTypeActive ? 'menu-up' : 'menu-down'" />
                                                        </template>
                                                        <b-dropdown-item value="DAY"
                                                            aria-role="listitem">Days</b-dropdown-item>
                                                        <b-dropdown-item value="MONTH"
                                                            aria-role="listitem">Months</b-dropdown-item>
                                                        <b-dropdown-item value="YEAR"
                                                            aria-role="listitem">Years</b-dropdown-item>
                                                    </b-dropdown>
                                                </div>
                                            </div>

                                            <div v-if="dateReportType == 'DAY'" class="columns">
                                                <div class="column is-8">
                                                    <div class="columns">
                                                        <div class="column">
                                                            <b-field>
                                                                <b-datepicker @input="changeDateReportType"
                                                                    v-model="dateReportFrom" placeholder="From Date"
                                                                    icon="calendar-today"></b-datepicker>
                                                            </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field>
                                                                <b-datepicker @input="changeDateReportType"
                                                                    v-model="dateReportTo" placeholder="To Date"
                                                                    icon="calendar-today"></b-datepicker>
                                                            </b-field>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="columns is-align-items-center">
                                                <div class="column is-9 ">
                                                    <div class="graph-div">
                                                        <bar-chart :chart-data="timeQuestionsGraphData"
                                                            :extra-options="barChartOptions"></bar-chart>
                                                    </div>
                                                </div>
                                                <div class="column is-3">
                                                    <img :src="require('@/assets/images/icons/analytics/game-on.svg')" />
                                                </div>
                                            </div>
                                        </div>

                                        <!--Arrow Divider Start-->
                                        <div class="column is-12 is-flex is-justify-content-center">
                                            <img style="height: 100px;"
                                                :src="require('@/assets/images/icons/analytics/down-arrow-swirl-green.svg')" />
                                        </div>
                                        <!--Arrow Divider End-->

                                        <!--Summary Questions Practiced per category graph-->
                                        <div class="column is-12">
                                            <p class="title is-5"><span class="analytics-title">Questions Practiced by Top
                                                    10
                                                    Categories</span>
                                            </p>
                                            <div class="columns is-align-items-center">
                                                <div class="column is-3">
                                                    <img :src="require('@/assets/images/icons/analytics/photo.svg')" />
                                                </div>
                                                <div class="column is-9">
                                                    <div class="graph-div">
                                                        <pie-chart :chart-data="questionsGraphData"
                                                            :extra-options="barChartOptions"></pie-chart>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--Arrow Divider Start-->
                                    <div class="column is-12 is-flex is-justify-content-center">
                                        <img style="height: 100px;"
                                            :src="require('@/assets/images/icons/analytics/down-arrow-swirl-blue.svg')" />
                                    </div>
                                    <!--Arrow Divider End-->

                                    <!--Details-->
                                    <div class="columns is-centered">
                                        <div class="column is-3">
                                            <b-dropdown v-model="category" @input="changeThisCategory()"
                                                class="has-text-left" aria-role="list" expanded>
                                                <template #trigger="{ active: isDetailsCategorySelectActive }">
                                                    <b-button style="border-radius: 0px!important;" expanded
                                                        :label="category ? fetchCategories.find(c => c._id === category).name : 'Select Category'"
                                                        type="is-dark"
                                                        :icon-right="isDetailsCategorySelectActive ? 'menu-up' : 'menu-down'" />
                                                </template>
                                                <b-dropdown-item v-for="cat in fetchCategories" :key="cat._id"
                                                    :value="cat._id" aria-role="listitem">{{ cat.name }}</b-dropdown-item>
                                            </b-dropdown>
                                            <img :src="require('@/assets/images/icons/analytics-bottom-right-arrow.png')" />
                                        </div>
                                        <div class="column is-9">
                                            <div class="analytics-detail-table-container">
                                                <table class="table is-fullwidth is-striped" id="analytics-detail-table">
                                                    <thead>
                                                        <tr :style="`background-color: #363636`">
                                                            <th>
                                                                <p class="title is-6 has-text-white">SKILL</p>
                                                            </th>
                                                            <th>
                                                                <p class="title is-6 has-text-white">UP-SCORE</p>
                                                            </th>
                                                            <th>
                                                                <p class="title is-6 has-text-white">TIME TAKEN</p>
                                                            </th>
                                                            <th>
                                                                <p class="title is-6 has-text-white">CORRECT ANSWERS</p>
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody v-if="fetchAnalyticsDetails.length">
                                                        <tr v-for="(row, rowIndex) in fetchAnalyticsDetails"
                                                            :key="`table-analytics-row-${rowIndex}`">
                                                            <td>{{ row.skill.name }}</td>
                                                            <td>{{ row.upscore }}</td>
                                                            <td>{{ (row.time_taken / 60).toFixed(2) }} mins</td>
                                                            <td>{{ row.questions_correct }} / {{ row.questions_attempted }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <empty-table v-if="!fetchAnalyticsDetails.length"
                                                    message="No skill analysis"></empty-table>
                                            </div>
                                        </div>
                                    </div>

                                    <!--Wrong Attempts-->
                                    <hr />
                                    <p class="title is-5"><span class="analytics-title">Questions Attempted
                                            Incorrectly</span></p>

                                    <div class="columns is-centered">
                                        <div class="column is-12">
                                            <div class="analytics-detail-table-container">
                                                <table class="table is-fullwidth is-striped" id="analytics-detail-table">
                                                    <thead>
                                                        <tr :style="`background-color: #363636`">
                                                            <th>
                                                                <p class="title is-6 has-text-white">QUESTION</p>
                                                            </th>
                                                            <th>
                                                                <p class="title is-6 has-text-white">SKILL</p>
                                                            </th>
                                                            <th>
                                                                <p class="title is-6 has-text-white">VIEW</p>
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr v-for="(row, rowIndex) in fetchQuestionResponses"
                                                            :key="`table-analytics-row-wrong-${rowIndex}`">

                                                            <td><question-text v-if="row.question"
                                                                    :text="row.question.question" /></td>
                                                            <td>{{ row.skill ? row.skill.name : "Random" }}</td>
                                                            <td><b-button type="is-dark"
                                                                    @click="$router.push({ name: 'quiz', query: { first_question: row.question._id }, params: { kid_id, skill_id: row.skill._id, category_id: row.skill.category, grade_subject_id: grade_subject } })">View</b-button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <empty-table v-if="!fetchQuestionResponses.length"
                                                    message="No incorrect attempts"></empty-table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import QuestionText from "@/components/Question/Quiz/QuestionText";
import SummaryTile from '@/components/Analytics/SummaryTile';
import BarChart from '@/components/Charts/BarChart'
import PieChart from '@/components/Charts/PieChart'
import EmptyTable from '@/components/EmptyTable'
export default {
    name: 'kid-analytics',
    components: {
        QuestionText,
        SummaryTile,
        BarChart,
        PieChart,
        EmptyTable
    },
    props: {
        kid_id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoading : false,
            isDateGraphReportTypeActive: false,
            dateReportType: "DAY",
            dateReportFrom: null,
            dateReportTo: null,
            primary_colors: ["#FF3838", "#96E937", "#449ff2", "#f6af5d"],
            lightColors: ["#C0EEE4", "#F8F988", "#FFCAC8", "#FF9E9E", "#FF8787", "#F8C4B4", "#E5EBB2", "#BCE29E", "#FCF9BE", "#FAAB78"],
            pieChartOptions: {
                legend: {
                    display: false
                },
                maintainAspectRatio: false,
                borderWidth: "10px",
                hoverBackgroundColor: "red",
                overBorderWidth: "10px",
                responsive: true
            },
            barChartOptions: {
                maintainAspectRatio: false,
                responsive: true
            },
            horizontalbarChartOptions: {
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                padding: 60,
                                fontColor: "#000",
                            },
                        },
                    ],
                    xAxes: [
                        {
                            ticks: {
                                padding: 60,
                                fontColor: "#000",
                            },
                        },
                    ],
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    enabled: false,
                },
            },
            subject: null,
            grade : null,
            grade_subject: null,
            category: null
        }
    },
    methods: {
        ...mapActions([
            'loadAnalyticsSummary',
            'loadCategories',
            'loadGradeSubjectDetails',
            'loadGrades',
            'loadSubjects',
            'loadGradeSubjects',
            'resetGradeSubjects',
            'loadAnalyticsDetails',
            'loadAnalyticsQuestionsPracticedByDate',
            'loadAnalyticsQuestionsPracticedByCategory',
            'loadQuestionResponses',
            'loadKidDetails'
        ]),
        changeThisGradeSubject() {
            if(!this.grade || !this.subject) return

            const grade_subject = this.fetchGradeSubjects.find(gs => (gs.subject._id === this.subject) && (gs.grade._id === this.grade))
            console.log({grade_subject})
            this.grade_subject = grade_subject?._id

            if(!grade_subject) return
            this.loadCategories({
                token: this.getTeacherToken,
                filter: {
                    grade_subject: this.grade_subject
                }
            })
            this.loadAnalyticsSummary({
                token: this.getTeacherToken,
                filter: {
                    grade_subject: this.grade_subject,
                    kid: this.kid_id
                }
            })

            this.changeDateReportType()

            this.changeCategoryReportType()

            // Loading questions attempted incorrectly
            this.loadQuestionResponses({
                token: this.getTeacherToken,
                filter: {
                    kid: this.kid_id,
                    is_details: true,
                    is_correct: false
                }
            })

        },
        changeThisCategory() {
            this.loadAnalyticsDetails({
                token: this.getTeacherToken,
                filter: {
                    category: this.category,
                    kid: this.kid_id
                }
            })
        },

        changeCategoryReportType() {
            this.loadAnalyticsQuestionsPracticedByCategory({
                token: this.getTeacherToken,
                filter: {
                    // from_date : this.dateReportFrom,
                    // to_date : this.dateReportTo,
                    kid: this.kid_id,
                    grade_subject: this.grade_subject
                }
            })
        },
        changeDateReportType() {
            if (this.dateReportType !== "DAY") {
                this.dateReportFrom = null
                this.dateReportTo = null
            }

            this.loadAnalyticsQuestionsPracticedByDate({
                token: this.getTeacherToken,
                filter: {
                    kid: this.kid_id,
                    type: this.dateReportType,
                    from_date: this.dateReportFrom,
                    to_date: this.dateReportTo,
                    grade_subject: this.grade_subject
                }
            })
        }
    },
    computed: {
        ...mapGetters([
            'getUserType',
            'getTeacherToken',
            'fetchAnalyticsSummary',
            'fetchCategories',
            'fetchKids',
            'fetchGradeSubjects',
            'fetchSubjects',
            'fetchGrades',
            'fetchAnalyticsDetails',
            'fetchCurrentKid',
            'fetchAnalyticsQuestionsPracticedByDate',
            'fetchAnalyticsQuestionsPracticedByCategory',
            'fetchQuestionResponses'
        ]),
        questionsGraphData() {
            let data = [], labels = [], backgroundColors = []

            const colors = this.lightColors
            for (let rowIndex in this.fetchAnalyticsQuestionsPracticedByCategory) {
                const row = this.fetchAnalyticsQuestionsPracticedByCategory[rowIndex]
                labels.push(row.category.name)
                data.push(row.count)
                backgroundColors.push(colors[rowIndex % (colors.length)])
            }

            return { labels, datasets: [{ label: 'No. of questions', backgroundColor: backgroundColors, data, barThickness: 10 }] }
        },
        timeQuestionsGraphData() {

            let data = [], labels = [], backgroundColors = []
            const colors = this.lightColors
            for (let rowIndex in this.fetchAnalyticsQuestionsPracticedByDate) {
                const row = this.fetchAnalyticsQuestionsPracticedByDate[rowIndex]
                labels.push(row._id)
                data.push(row.count)
                backgroundColors.push(colors[rowIndex % (colors.length)])
            }

            return { labels, datasets: [{ label: 'No. of questions', backgroundColor: backgroundColors, data }] }
        },
        timePracticedText() {
            let hours = 0, mins = 0
            let text = '0 h 0 m'
            if (this.fetchAnalyticsSummary && this.fetchAnalyticsSummary.time_taken) {
                let time_taken_in_secs = this.fetchAnalyticsSummary.time_taken
                hours = Math.floor(time_taken_in_secs / 3600)

                time_taken_in_secs -= (hours * 3600)
                mins = Math.round(time_taken_in_secs / 60)

                text = `${hours} h ${mins} m`
            }
            return text
        }
    },
    created() {

        //Resetting the old state
        this.resetGradeSubjects({
            token: this.getTeacherToken
        })

        this.loadGradeSubjects({
            token : this.getTeacherToken
        })

        this.loadGrades({
            token: this.getTeacherToken
        })

        this.loadSubjects({
            token: this.getTeacherToken
        })

        this.loadKidDetails({
            id: this.kid_id,
            token: this.getTeacherToken,
        });

        if(this.$route.query?.grade_subject){
            this.grade_subject = this.$route.query?.grade_subject
            this.changeThisGradeSubject()
        }

    }
}
</script>
<style scoped>
.flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .container {
    position: relative;
  }
  
  .bg-img {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .bg-img div {
    display: flex;
    position: absolute;
    width: auto;
  }
  
  .button {
    flex-direction: row;
    padding: 1vw 1.25vw;
    width: 100%;
    background: #8919e7;
    border-radius: 1vw;
    color: #fff;
    gap: 1vw;
    cursor: pointer;
    position: relative;
    text-transform: capitalize;
  }
  .button.outline {
    border: 0.063rem solid #8919e7;
    background: #fff;
    color: #000;
  }
  .link {
    cursor: pointer;
  }
  .main {
    align-items: center;
    margin: 6.76vw 0vw;
    position: relative;
    gap: 2.4vw;
  }
  /* responsive page*/
  
  /* tablet */
  @media screen and (max-width: 1023px) {
    .title{
      font-size: 3.5vw !important;
    }
  }
  
  /* Mobiles */
  @media screen and (max-width: 767px) {
    .title {
      font-size: 4vw !important;
    }
  }
  
  @media screen and (max-width: 467px){
    .title{
      font-size: 5vw !important;
    }
  }
  .practice-bg {
    position: absolute;
    z-index: 10;
  }
  .practice-bg img {
    height: 150px;
    max-width: 100%;
    width: auto;
  }
  
  .img1 {
    top: 0;
    left: 0;
  }
  
  .img2 {
    top: -3%;
    left: 17%;
  }
  .img2 img {
    height: 85px;
  }
  
  .img3 {
    top: -9%;
    left: 43%;
    z-index: 0;
  }
  
  .img4 {
    right: 4%;
    top: -5%;
  }
  .img4 .img4-inner {
    position: relative;
  }
  .img4 .img4-inner .pencil {
    position: absolute;
    left: -12%;
  }
  
  .img5 {
    right: 13%;
    bottom: 22%;
  }
  .img5 img {
    height: auto;
  }
  
  .img6 {
    right: -5%;
    bottom: 0;
  }
  .img6 img {
    height: auto;
  }
  
  .img7 {
    bottom: 0;
    left: -2%;
    right: -2%;
  }
  
  .main .card {
    box-shadow: none;
  }
  .main .card .card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .main .card .card-content #tab-content {
    background: linear-gradient(75.66deg, rgba(138, 25, 231, 0.1) 9.81%, rgba(49, 200, 255, 0.1) 95.1%);
    border-radius: 30px 30px 0px 0px;
    width: 100%;
    padding: 59px 68px 115px;
  }
  .main .card .card-content #tab-content .card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
  }
  .main .card .card-content #tab-content .card-container .practice-card {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 15px;
    max-width: 312px;
    aspect-ratio: 312/217;
    flex: 1 1 312px;
  }
  .main .card .card-content #tab-content .card-container .practice-card:hover {
    background: linear-gradient(58.3deg, #8919e7 -26.52%, #31c7ff 104.77%);
    box-shadow: 5px 37px 27px -15px rgba(4, 45, 61, 0.13);
  }
  .main .card .card-content #tab-content .card-container .practice-card:hover .card-title,
  .main .card .card-content #tab-content .card-container .practice-card:hover .card-content {
    color: #fff;
  }
  .main .card .card-content #tab-content .card-container .practice-card .card-title {
    padding: 16px 30px;
    border-bottom: 1px solid #e1e1e1;
    text-transform: capitalize;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #232323;
  }
  .main .card .card-content #tab-content .card-container .practice-card .card-content {
    padding: 20px 30px;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #6d6d6d;
  }
  .main .card .card-content .tabs {
    width: 100%;
    width: 100%;
    justify-content: center;
    margin-bottom: 0;
    z-index: 1;
  }
  .main .card .card-content .tabs ul {
    border: 1px solid #8919e7;
    border-bottom: none;
    border-radius: 28.5px 28.5px 0px 0px;
    justify-content: center;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    flex-shrink: 1;
    max-width: 43.5%;
    background: #fff;
  }
  .main .card .card-content .tabs li.active {
    background: #8919e7;
    border-radius: 28.5px 28.5px 0px 0px;
  }
  .main .card .card-content .tabs li {
    all: unset;
    width: 100%;
    max-width: 50%;
  }
  .main .card .card-content .tabs li a {
    padding: 21px 0 17px;
  }
  
  @media screen and (max-width: 768px) {
    .main .card .card-content #tab-content {
      padding: 25px 20px;
    }
    .practice-bg {
      display: none;
    }
    .card-container {
      justify-content: center;
    }
    .main .card .card-content .tabs ul {
      max-width: 85%;
    }
    .main .card .card-content .tabs li a {
      padding: 10px 0 10px;
    }
  }
  .grade-card {
    padding: 12px 10px 12px 10px;
    border-radius: 5px;
  }
  
  .grade-heading {
    padding: 5px 50px 5px 10px;
    color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    margin-left: -10px;
  }
  
  .grade-description {
    margin: 14px 0 12px 0;
  }
  
  .grade-subject-label {
    color: #000;
    padding-top: 12px;
  }
.analytics-title {
    padding: 5px 30px 5px 10px;
    background: #1795cc;
    color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    margin-left: -20px;
}

.button.is-primary-red {
    background-color: #f65c5c;
}

.analytics-detail-table-container {
    position: relative;
    border-radius: 10px;
}

#analytics-detail-table>thead>tr>th {
    padding: 12px 10px;
}

.graph-div {
    max-height: 400px;
}

.pie-graph-div {
    max-height: 400px;
}</style>